import { useAuth } from "contexts/AuthProvider";
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

const SignInCallback = () => {
  const { finishLogin } = useAuth();
  const [redirect, setRedirect] = useState('');

  useEffect(() => {
    finishLogin().then((usr: any) => {
      setRedirect('/order/cart/sync');
    });
  }, []);
  return redirect ? <Navigate to={redirect} /> : <></>;
}

export default SignInCallback;